/**
 * @generated SignedSource<<9bd48343491afa3ec3d243acb533bc52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalsCreatedRowFragment$data = {
  readonly delegateMetrics: {
    readonly proposalsCreated: number;
  };
  readonly proposed: ReadonlyArray<{
    readonly number: string;
    readonly title: string;
  }>;
  readonly " $fragmentType": "ProposalsCreatedRowFragment";
};
export type ProposalsCreatedRowFragment$key = {
  readonly " $data"?: ProposalsCreatedRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalsCreatedRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalsCreatedRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateMetrics",
      "kind": "LinkedField",
      "name": "delegateMetrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "proposalsCreated",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnChainProposal",
      "kind": "LinkedField",
      "name": "proposed",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "7526ea66646412eefa697bcf4fd1f40d";

export default node;
